import React from 'react'
import Icon from '@/components/Icon'
import PropTypes from 'prop-types'
import valueFallbackComparer from '@/utils/valueComparer'

Approval.propTypes = {
  approved: PropTypes.bool,
  validating: PropTypes.bool,
  needApproval: PropTypes.bool,
  value: PropTypes.any,
  onRevert: PropTypes.func,
  originalValue: PropTypes.any,
  approvedValue: PropTypes.any,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export function Approval (props) {
  const { approved, value, validating, needApproval, onRevert, originalValue, approvedValue } = props
  const showNotApproved = approved === false
  const valueUnchanged = valueFallbackComparer(approvedValue, value)

  const css = (showNotApproved && valueUnchanged) ? 'input-invalid has-error' : 'input-valid'

  return (
    <div className={css}>
      {props.children}
      {showNotApproved && valueUnchanged && <Icon name='x' />}
      {!showNotApproved && !validating && needApproval && <Icon name='check green' />}
      {!valueFallbackComparer(originalValue, value) && <a className={'button-reset'} onClick={onRevert}><Icon name={'undo'} /></a>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Approval.js